import type { FieldDef } from '../../domain/types'
import type { EffectiveCustomFieldDto } from '../dto/customField.dto'

// Mapeia o tipo numérico do backend (CustomFields.Type) para o tipo do FieldDef da UI.
// Valores espelham o enum canônico do monolito: 0 Text, 1 Number, 2 Date, 3 Cpf, 4 Select,
// 5 Cnpj; extensões da unificação: 6 Url, 7 Bool.
function uiType(type: number | string): FieldDef['type'] {
  switch (type) {
    case 1: return 'number'
    case 2: return 'date'
    case 3: return 'cpf'
    case 4: return 'select'
    case 5: return 'cnpj'
    case 6: return 'url'
    case 7: return 'bool'
    case '1': return 'number'
    case '2': return 'date'
    case '3': return 'cpf'
    case '4': return 'select'
    case '5': return 'cnpj'
    case '6': return 'url'
    case '7': return 'bool'
    case 'Bool': return 'bool'
    case 'Boolean': return 'bool'
    case 'Checkbox': return 'bool'
    default: return 'text' // 0 Text
  }
}

function anchorName(a?: number | string): string | undefined {
  if (a === 1 || a === '1' || a === 'Customer') {return 'Customer'}
  if (a === 2 || a === '2' || a === 'Journey') {return 'Journey'}
  if (a === 3 || a === '3' || a === 'Ticket') {return 'Ticket'}
  if (a === 4 || a === '4' || a === 'Transition') {return 'Transition'}
  return a?.toString()
}

// EffectiveCustomFieldDto (backend) → FieldDef (UI, schema-driven do FieldRenderer).
// `key` = metadataKey (casa com o bag de metadata enviado/lido). options usam o `value`
// (é o que o backend valida em campos Select).
export function fieldDef(dto: EffectiveCustomFieldDto): FieldDef {
  const options = dto.options ?? dto.Options
  return {
    key: dto.metadataKey ?? dto.MetadataKey ?? '',
    label: dto.title ?? dto.Title ?? '',
    type: uiType(dto.type ?? dto.Type ?? 0),
    required: dto.required ?? dto.Required ?? false,
    options: options?.length ? options.map((o) => ({ label: o.name, value: o.value })) : undefined,
    anchor: anchorName(dto.anchor ?? dto.Anchor ?? dto.anchorDefault ?? dto.AnchorDefault),
    currentValue: dto.currentValue ?? dto.CurrentValue,
    summary: dto.showInList ?? dto.ShowInList,
  }
}

export function fieldDefs(list: EffectiveCustomFieldDto[]): FieldDef[] {
  return (list ?? []).map(fieldDef).filter((field) => field.key && field.label)
}
